import customEmojiConfig from './customEmojiConfig.json'

// 直接使用对象格式的配置
const emojiConfig = customEmojiConfig.customEmojis

export const emojiDirective = {
  mounted(el, binding) {
    // 初始处理
    processEmojiContent(el)
    
    // 为contenteditable元素添加智能监听
    if (el.isContentEditable) {
      let isProcessing = false
      let lastProcessedContent = el.innerHTML
      
      // 使用MutationObserver监听内容变化
      const observer = new MutationObserver((mutations) => {
        // 如果正在处理中，跳过
        if (isProcessing) return
        
        // 检查是否有文本变化
        const hasTextChange = mutations.some(mutation => 
          mutation.type === 'characterData' || 
          (mutation.type === 'childList' && 
           Array.from(mutation.addedNodes).some(node => node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE))
        )
        
        if (hasTextChange) {
          isProcessing = true
          
          // 延迟处理，确保内容已经稳定
          setTimeout(() => {
            // 检查当前内容是否与上次处理的不同
            if (el.innerHTML !== lastProcessedContent) {
              processEmojiContent(el)
              lastProcessedContent = el.innerHTML
            }
            isProcessing = false
          }, 50)
        }
      })
      
      // 开始观察
      observer.observe(el, {
        childList: true,
        subtree: true,
        characterData: true
      })
      
      // 保存observer以便清理
      el._emojiObserver = observer
    }
  },
  updated(el) {
    // 对于非contenteditable元素，正常更新
    if (!el.isContentEditable) {
      processEmojiContent(el)
    }
  },
  beforeUnmount(el) {
    // 清理MutationObserver
    if (el._emojiObserver) {
      el._emojiObserver.disconnect()
      delete el._emojiObserver
    }
  }
}

function processEmojiContent(el) {
  // 保存当前光标位置
  const selection = window.getSelection()
  let range = null
  let anchorNode = null
  let anchorOffset = 0
  
  if (selection && selection.rangeCount > 0) {
    range = selection.getRangeAt(0)
    anchorNode = selection.anchorNode
    anchorOffset = selection.anchorOffset
  }
  
  const content = el.innerHTML
  
  // 提取已有的表情图片，保留它们的位置
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = content
  
  // 获取所有文本节点
  const walker = document.createTreeWalker(
    tempDiv,
    NodeFilter.SHOW_TEXT,
    null,
    false
  )
  
  const textNodes = []
  let node
  while (node = walker.nextNode()) {
    textNodes.push(node)
  }
  
  // 对每个文本节点处理表情符号
  textNodes.forEach(textNode => {
    let text = textNode.nodeValue || ''
    let modified = false
    
    // 按模式长度降序排序，确保长模式先匹配
    const sortedPatterns = Object.keys(emojiConfig).sort((a, b) => b.length - a.length)
    
    sortedPatterns.forEach(pattern => {
      if (text.includes(pattern)) {
        const filename = emojiConfig[pattern]
        const regex = new RegExp(pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
        const replacement = `<img src="${getEmojiUrl(filename)}" alt="${pattern}" class="inline-emoji" data-emoji-pattern="${pattern}" width='20'/>`
        text = text.replace(regex, replacement)
        modified = true
      }
    })
    
    if (modified) {
      // 创建包含表情图片的新节点
      const fragment = document.createDocumentFragment()
      const tempSpan = document.createElement('span')
      tempSpan.innerHTML = text
      while (tempSpan.firstChild) {
        fragment.appendChild(tempSpan.firstChild)
      }
      
      // 替换原始文本节点
      textNode.parentNode?.replaceChild(fragment, textNode)
    }
  })
  
  const newContent = tempDiv.innerHTML
  
  // 只有当内容确实发生变化时才更新
  if (newContent !== el.innerHTML) {
    el.innerHTML = newContent
    
    // 恢复光标位置
    if (range && anchorNode) {
      try {
        selection?.removeAllRanges()
        
        // 尝试恢复原来的光标位置
        if (anchorNode.parentNode && anchorNode.parentNode.isConnected) {
          const newRange = document.createRange()
          newRange.setStart(anchorNode, anchorOffset)
          newRange.collapse(true)
          selection?.addRange(newRange)
        } else {
          // 如果原来的节点不存在了，将光标移到末尾
          const newRange = document.createRange()
          newRange.selectNodeContents(el)
          newRange.collapse(false)
          selection?.addRange(newRange)
        }
      } catch (error) {
        console.warn('恢复光标位置失败:', error)
      }
    }
  }
}

function getEmojiUrl(filename) {
  return `https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/kf/${filename}`
}